export default __webpack_public_path__ + "static/media/etherael-attack.0a8ace40.wav";